import { useEvent } from "@/app/hooks/use-event"
import { useWalletConnect } from "@/app/wallet-connect/hooks"
import { WalletConnectMoleculeReatom } from "@/app/wallet-connect/store.reatom"
import { useMolecule } from "bunshi/react"
import { useEffect, useRef } from "react"

export function useConnectStatus<Args extends unknown[], Return>(
  fn: (...args: Args) => Return,
) {
  const ref = useRef<Args | undefined>(undefined)
  const prevStatusRef = useRef<string | undefined>(undefined)

  const { logIn } = useMolecule(WalletConnectMoleculeReatom)
  const { status } = useWalletConnect() // Get the status value, not the atom
  const { logIn: logInFn } = logIn()

  useEffect(() => {
    return () => {
      ref.current = undefined
    }
  }, [])

  // Watch status changes
  useEffect(() => {
    const prevStatus = prevStatusRef.current

    if (prevStatus === "connecting" && status === "connected" && ref.current) {
      const args = ref.current
      ref.current = undefined
      fn(...args)
    }

    prevStatusRef.current = status
  }, [status, fn])

  const func = useEvent((...args: Args) => {
    ref.current = args
    logInFn()
  })
  return func
}
